import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/student-storage-and-shipping-services.jpg'),
    alt: 'student storage and shipping services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'student storage and shipping services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>Student</span><span>Storage And Shipping Services</span>',
  description:
    "Looking for a convenient way to store and ship your belongings while you're away at school? Our Student Storage and Shipping Services offer affordable, secure, and flexible solutions to help students store their items and ship them anywhere.",
  image: {
    url: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/hero-image.jpg',
    alt: 'Affordable Student Storage And Shipping Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for Student Storage & Shipping' }
}

export const ourProcessSectionContent = {
  title: 'How Student Storage and Shipping Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/how-student-storage-and-shipping-services-work.png',
    alt: 'How Student Storage and Shipping Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Pickup and Delivery',
      description:
        "Schedule a pickup time that works for you, and we’ll come to collect your items. When you're ready, we’ll ship your items to your destination, whether it’s home, another dorm, or a new city.",
      image: {
        src: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/easy-pickup-and-delivery.png',
        alt: 'Easy Pickup and Delivery'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Solutions',
      description:
        "We store your belongings in secure, climate-controlled facilities to ensure their safety while you're away.",
      image: {
        src: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/secure-storage-solutions.png',
        alt: 'Secure Storage Solutions'
      }
    },
    {
      id: 3,
      title: 'Nationwide and International Shipping',
      description:
        "We offer shipping options to any destination, whether you're staying in the U.S. or studying abroad, making it easy to get your items wherever you need them.",
      image: {
        src: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/nationwide-and-international-shipping.png',
        alt: 'Nationwide and International Shipping'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Student Storage Solutions',
  description:
    "Our student storage and shipping services are designed with convenience and affordability in mind. Whether you're moving out for the summer or need a secure place for your belongings, we've got you covered.",
  image: {
    src: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/affordable-student-storage-solutions.jpg',
    alt: 'Affordable Student Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Student Storage and Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Affordable Rates',
      description:
        'We offer competitive pricing designed for students, so you don’t have to worry about breaking your budget.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Affordable Rates'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage Duration',
      description:
        "Store your belongings for the duration that fits your schedule, whether it's for the summer, a semester, or longer.",
      image: {
        src: '/images/v2/pages/common/flexible-storage-duration.png',
        alt: 'Flexible Storage Duration'
      }
    },
    {
      id: 3,
      title: 'Safe and Secure',
      description:
        'Your items are kept in secure facilities, with 24/7 surveillance and climate control to ensure they stay in perfect condition.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Safe and Secure'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Student Storage and Shipping Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students Going Home for the Summer',
          description: "Store your belongings for the summer and ship them back to school when you're ready to return."
        },
        {
          id: 2,
          title: 'Students Moving to a New School',
          description:
            'Relocating for a new semester? Let us help you with moving and shipping your belongings to your new school.'
        },
        {
          id: 3,
          title: 'International Students',
          description:
            'Simplify the process of shipping your items from home to your new school with our international shipping services.'
        },
        {
          id: 4,
          title: 'Graduating Students',
          description:
            "If you're graduating and need to store or ship your items to a new destination, our services make it easy."
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/who-should-use-student-storage-and-shipping-services.jpg',
        alt: 'Who Should Use Student Storage and Shipping Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Student Storage and Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Storage for Summer Break',
      description:
        "Need a place to store your items over the summer? Our short-term storage options are perfect for students who need a secure place for their belongings while they're away.",
      image: {
        src: '/images/v2/pages/common/short-term-storage.png',
        alt: 'Storage for Summer Break'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'International Shipping',
      description:
        "Whether you're studying abroad or moving to a different country, we offer reliable and affordable international shipping options for students.",
      image: {
        src: '/images/v2/pages/common/global-shipping-solutions.png',
        alt: 'International Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Storage for Moving',
      description:
        'Moving to a new dorm or apartment? We provide secure storage solutions during your move, along with efficient shipping services.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Storage for Moving'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Packing and Shipping Supplies',
      description:
        'We offer all the packing supplies you need to keep your belongings safe during storage and shipping, including boxes, tape, and bubble wrap.',
      image: {
        src: '/images/v2/pages/common/packing-and-moving-supplies.png',
        alt: 'Packing and Shipping Supplies'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Student Storage and Shipping?',

  image: {
    url: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/why-choose-us-for-student-storage-and-shipping.jpg',
    alt: 'Why Choose Us for Student Storage and Shipping?'
  },

  articles: [
    {
      id: 1,
      title: 'Convenient Scheduling',
      description: "Book your pickup and delivery at your convenience, with flexible options for when you're available."
    },
    {
      id: 2,
      title: 'Safe and Secure Facilities',
      description:
        'Your items are stored securely in climate-controlled units with 24/7 surveillance, ensuring they stay safe while you’re away.'
    },
    {
      id: 3,
      title: 'Affordable and Transparent Pricing',
      description:
        'Enjoy clear pricing with no hidden fees, making it easy for students to budget their storage and shipping needs.'
    },
    {
      id: 4,
      title: 'Easy Access to Your Items',
      description:
        'Get quick access to your stored belongings whenever you need them, without hassle or long wait times.'
    },
    {
      id: 5,
      title: 'Flexible Storage Options',
      description: 'Whether you need short-term or long-term storage, we offer flexible plans to fit your needs.'
    },
    {
      id: 6,
      title: 'Shipping Across the Globe',
      description:
        'We offer international shipping services, so you can send your items home or to a new location, no matter where you are.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Student Storage And Shipping Services Available Fast',
  description:
    'Affordable student storage and shipping services available now. Secure, fast, and convenient solutions for storing and shipping student belongings.',
  image: {
    src: '/images/v2/pages/landing-pages/student-storage-and-shipping-services/student-storage-and-shipping-services-available-fast.png',
    alt: 'Student Storage And Shipping Services Available Fast'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Your Student Storage' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping Partners',
  description: 'We work with leading global shipping partners to ensure reliable delivery of your stored items.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is our trusted partner for reliable and timely deliveries of your stored items to destinations nationwide and internationally.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL works with us to provide efficient and affordable international shipping services for students storing and shipping their items globally.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS helps ensure your items are shipped quickly and securely to your new location or back home for the break.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
